import NgrxAuth from '../../auth/Auth'
import { CALL_API } from '../../util/RBRestMiddleware'

export const DENTALEXPENSE_LOADING = 'DENTALEXPENSE_LOADING'
export const DENTALEXPENSE_SUCCESS = 'DENTALEXPENSE_SUCCESS'
export const DENTALEXPENSE_FAILED = 'DENTALEXPENSE_FAILED'

// SearchDentalProcCode
export const searchDentalProcCode = (procCode, onSuccess, onError) => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        path: `/submitaclaim/${NgrxAuth.memberId}/dentalExpenses/${procCode}`,
        prefix: 'DENTALEXPENSE',
        onSuccess,
        onError
      }
    })
  }
}
export const searchDetailToothCode = (dentalProcCode, segmentCode, onSuccess, onError) => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        path: `/submitaclaim/${NgrxAuth.memberId}/SearchDentalSegmentCode`,
        query: { dentalProcCode, segmentCode },
        method: 'post',
        prefix: 'DENTALEXPENSE_TOOTHCODE',
        onSuccess,
        onError
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/submitDentalExpenseActions.js